import React from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import { Head, MainLayout, SubscriptionsRead } from "@/components/index";
import { clearUnnecessaryPropertiesForBreadcrumbs } from "@/shared/utils/breadcrumbs/breadcrumbs";
import { loadFolder } from "@/shared/server-api/api";
import { MENU_ITEM_LOCATION } from "@/shared/utils/menu";
import { MenuItemsList, MainMenuItem, MenuItems } from "../../next/utils/MenuItems.constants";
import { URLS } from "@/shared/utils/url/url";
import { parseHost, parseProtocol } from "@/shared/utils/appServer/appServer";
import { getSSRCommonData } from "../../next/utils/ssr/ssr";
import Subscriptions from "@/components/subscriptions/Subscriptions";

const SubscriptionPage = ({ breadcrumbsProps, isSubscription, pageUrl }) => {
  return (
    <MainLayout breadcrumbs={breadcrumbsProps}>
      <Head pageTitle={breadcrumbsProps.title} url={pageUrl} />

      {isSubscription ? <Subscriptions /> : <SubscriptionsRead />}
    </MainLayout>
  );
};

export async function getServerSideProps(context) {
  const {
    localeData: { locale },
    landingData,
  } = await getSSRCommonData(context);

  if (landingData.isLanding) {
    return {
      notFound: true,
    };
  }

  const translate = await serverSideTranslations(locale, ["common"]);
  const { folder } = await loadFolder(locale);
  const homeItems = MenuItemsList.filter(({ locations }) =>
    locations.includes(MENU_ITEM_LOCATION.HOME),
  );

  const subscription = context.query?.subscription;

  if (!subscription) {
    return {
      redirect: {
        permanent: false,
        destination: `${URLS.subscription}/subscriptions`,
      },
    };
  }

  const mainCrumb = {
    ...MainMenuItem,
    children: [...folder.children, ...homeItems],
  };

  const breadcrumbsProps = {
    title: MenuItems.subscription.label,
    breadcrumbs: clearUnnecessaryPropertiesForBreadcrumbs([mainCrumb, MenuItems.subscription]),
  };

  const host = parseHost(context.req);
  const proto = parseProtocol(context.req, host);
  const urlOriginReq = `${proto}//${host}`;

  return {
    props: {
      isSubscription: subscription?.length < 3,
      breadcrumbsProps,
      urlOrigin: urlOriginReq,
      pageUrl: urlOriginReq + context.req.url,
      ...translate,
      ...landingData,
    },
    notFound: false,
  };
}

export default SubscriptionPage;
